import type {
  ActionSource,
  ActionSourceChatbot,
  ABTEventsSchema,
  ABTPossibleRelations,
  ActionSourceVoicebot,
  ActionSourceSurveyV2,
  ActionSourceExternalLinkV2,
  ActionSourceMeetingTemplate,
} from 'src/types/audience-actions';
import type {AudienceABTAction} from 'src/action-creators/audience-actions';

import {
  RECEIVE_ABT_EVENTS,
  RECEIVE_ABT_RELATIONS,
  RECEIVE_JOURNEYS_ACTION,
  RECEIVE_CHATBOTS_ACTION,
  RECEIVE_WORKFLOWS_ACTION,
  RECEIVE_VOICEBOTS_ACTION,
  RECEIVE_SURVEY_V2_ACTION,
  RECEIVE_EXTERNAL_LINK_V2_ACTION,
  RECEIVE_MEETING_TEMPLATES_ACTION,
} from 'src/action-creators/audience-actions';


export type State = {
  events: ABTEventsSchema;
  relations: ABTPossibleRelations;
  sourceLimit: number;
  journeysMap: Map<number, Array<ActionSource>>;
  workflowsMap: Map<number, Array<ActionSource>>;
  chatbotsMap: Map<number, Array<ActionSourceChatbot>>;
  voicebotsMap: Map<number, Array<ActionSourceVoicebot>>;
  surveyV2Map: Map<number, Array<ActionSourceSurveyV2>>;
  externalLinkV2Map: Map<number, Array<ActionSourceExternalLinkV2>>;
  meetingTemplatesMap: Map<number, Array<ActionSourceMeetingTemplate>>;
  totalJourneysCount: number;
  totalWorkflowsCount: number;
  totalChatbotsCount: number;
  totalVoicebotsCount: number;
  totalSurveyV2Count: number;
  totalExternalLinkV2Count: number;
  totalMeetingTemplatesCount: number;
};

const initialState = {
  events: [],
  relations: {},
  sourceLimit: 0,
  journeysMap: new Map(),
  workflowsMap: new Map(),
  chatbotsMap: new Map(),
  voicebotsMap: new Map(),
  surveyV2Map: new Map(),
  externalLinkV2Map: new Map(),
  meetingTemplatesMap: new Map(),
  totalJourneysCount: 0,
  totalChatbotsCount: 0,
  totalSurveyV2Count: 0,
  totalWorkflowsCount: 0,
  totalVoicebotsCount: 0,
  totalExternalLinkV2Count: 0,
  totalMeetingTemplatesCount: 0,
};

export default (
  state: State = initialState,
  action: AudienceABTAction,
): State => {
  switch (action.type) {
    case RECEIVE_ABT_EVENTS: {
      const {events, sourceLimit} = action.payload;
      return {
        ...state,
        events,
        sourceLimit,
      };
    }
    case RECEIVE_ABT_RELATIONS: {
      return {
        ...state,
        relations: action.payload,
      };
    }
    case RECEIVE_JOURNEYS_ACTION: {
      const {journeys, pageNumber, isNew} = action.payload;
      const tempJourneysMap = isNew ? new Map() : new Map(state.journeysMap);
      return {
        ...state,
        journeysMap: tempJourneysMap.set(pageNumber, journeys),
        totalJourneysCount: action.payload.totalCount,
      };
    }
    case RECEIVE_WORKFLOWS_ACTION: {
      const {workflows, pageNumber, isNew} = action.payload;
      const tempWorkflowsMap = isNew ? new Map() : new Map(state.workflowsMap);
      return {
        ...state,
        workflowsMap: tempWorkflowsMap.set(pageNumber, workflows),
        totalWorkflowsCount: action.payload.totalCount,
      };
    }
    case RECEIVE_CHATBOTS_ACTION: {
      const {chatbots, pageNumber, isNew, totalCount} = action.payload;
      const tempChatbotsMap = isNew ? new Map() : new Map(state.chatbotsMap);
      return {
        ...state,
        chatbotsMap: tempChatbotsMap.set(pageNumber, chatbots),
        totalChatbotsCount: totalCount,
      };
    }
    case RECEIVE_VOICEBOTS_ACTION: {
      const {voicebots, pageNumber, isNew, totalCount} = action.payload;
      const tempVoicebotsMap = isNew ? new Map() : new Map(state.voicebotsMap);
      return {
        ...state,
        voicebotsMap: tempVoicebotsMap.set(pageNumber, voicebots),
        totalVoicebotsCount: totalCount,
      };
    }
    case RECEIVE_SURVEY_V2_ACTION: {
      const {surveyV2, pageNumber, isNew, totalCount} = action.payload;
      const tempSurveyV2Map = isNew ? new Map() : new Map(state.surveyV2Map);
      return {
        ...state,
        surveyV2Map: tempSurveyV2Map.set(pageNumber, surveyV2),
        totalSurveyV2Count: totalCount,
      };
    }
    case RECEIVE_EXTERNAL_LINK_V2_ACTION: {
      const {externalLinkV2, pageNumber, isNew, totalCount} = action.payload;
      const tempExternalLinkV2Map = isNew
        ? new Map()
        : new Map(state.externalLinkV2Map);
      return {
        ...state,
        externalLinkV2Map: tempExternalLinkV2Map.set(
          pageNumber,
          externalLinkV2,
        ),
        totalExternalLinkV2Count: totalCount,
      };
    }
    case RECEIVE_MEETING_TEMPLATES_ACTION: {
      const {meetingTemplates, pageNumber, isNew, totalCount} = action.payload;
      const tempMeetingTemplatesMap = isNew
        ? new Map()
        : new Map(state.meetingTemplatesMap);
      return {
        ...state,
        meetingTemplatesMap: tempMeetingTemplatesMap.set(
          pageNumber,
          meetingTemplates,
        ),
        totalMeetingTemplatesCount: totalCount,
      };
    }
  }
  return state;
};
